<template>
  <article>
    <div class="table_card">
      <div class="table_card__head">
        <p class="table_card__head--title">
          Búsqueda de Usuario
        </p>
      </div>
      <div class="table_card__body">
        <v-layout row wrap >
          <v-flex xs6 row>
            <input
              v-model="searching_data"
              placeholder="Ingrese el documento o correo electrónico"
              required
              class="input_solid"
              style="width: 98% !important"
            >
            <img
              src="@/assets/img/icons/search-icon.svg"
              class="button_search"
              style="margin-left: -55px"
            >
          </v-flex>
          <v-flex xs6 class="pl-2">
            <button
              type="button"
              class="faccess_button"
              @click="find_access_devices()"
              :disabled="searching_data == ''"
            >Consultar</button>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div v-if="valid">
      <section class="access_devices__container table_card__head mt-4">
        <button
          type="button"
          class="faccess_button access_devices__button"
          @click="$router.push({name:'create_access_device', params:{user_id: current_user.id}})"
        >Asociar dispositivo</button>
        <div class="access_devices__header">
          <div class="access_devices__header--item">
            <span>No. Documento</span>
            <p>
              {{this.current_user.attributes.rut}}
            </p>
          </div>
          <div class="access_devices__header--item">
            <span>Email</span>
            <p>
              {{this.current_user.attributes.email}}
            </p>
          </div>
        </div>
        <section class="access_devices__devices">
          <div class="" v-if="access_devices.length > 0">
            <section class="access_devices__devices--header">
              <div class="access_devices__devices--item access_devices__header--item" style="height: 50px;">
                <span>Tipo de dispositivo</span>
              </div>
              <div class="access_devices__devices--item access_devices__header--item" style="height: 50px;">
                <span>UUID / Placa</span>
              </div>
            </section>
            <section
              class="access_devices__devices--header"
              style="height: 40px;"
              v-for="device in access_devices"
              :key="device.id">
              <div class="access_devices__devices--item access_devices__header--item">
                <p>{{filter_device_type(device.device_type)}}</p>
              </div>
              <div class="access_devices__devices--item access_devices__header--item">
                <p>{{device.uuid}}</p>
              </div>
              <div
                class="access_devices__devices--icon"
                @click="delete_item(device.id)">
                Eliminar
              </div>
            </section>
          </div>
          <div class="" v-else>
            <p>Este usuario no tiene dispositivos asociados</p>
          </div>
        </section>
      </section>
    </div>
    <section
      v-if="show_delete_validation"
      class="access_devices__modal">
      <section class="access_devices__modal--container">
        <p class="access_devices__modal--text">
          ¿Esta seguro que desea eliminar el dispositivo de este usuario?
        </p>
        <div class="access_devices__modal--buttons">
          <div
            class="access_devices__modal--button"
            @click="show_delete_validation = false">
            Cancelar
          </div>
          <div
            class="access_devices__modal--button active"
            @click="delete_device()">
            Eliminar
          </div>
        </div>
      </section>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      deleted_item: null,
      show_delete_validation: false,
      access_devices: [],
      current_user: {
        attributes:{
          email: '',
          rut:''
        }
      },
      searching_data: '',
      valid: false,
      user: {
        rut: '',
        email:'',
        company: this.getCompany().id
      }
    }
  },
  methods:{
    find_access_devices(){
      if(this.validate_data(this.searching_data)){
        console.log(this.searching_data);
        this.user.email = this.searching_data
      }else{
        console.log(this.searching_data);
        console.log(this.user);
        this.user.rut = this.searching_data
      }
      try {
        this.$http.get('app/access_devices/find_access_devices', {
          headers: {
              "X-Device-ID" : this.getDeviceId(),
              // "Authorization" : 'Bearer ' + this.getUserToken()
          },
          params: this.user
        }).then(function(response){
          console.log(response);
          if(response.body != null){
            this.access_devices = []
            this.access_devices = response.body.meta.access_devices
            console.log(this.access_devices);
            this.access_devices
            this.current_user = response.body.data
            this.user.email = '',
            this.user.rut = ''
            console.log("<<<<<<<<<<<<<<<<Current User");
            console.log(this.current_user);
            this.valid = true
          }else{
            this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
            this.updateIsInAlert(true);
          }
        }, function(response){
          console.log(response);
          this.user.rut = ''
          this.user.email = ''
          this.updateAlertMessage('No se ha encontrado el usuario con el documento o correo ingresado')
          this.updateIsInAlert(true);
        })
      } catch (e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true);
      }
    },
    validate_data(searching_data){
      let re = /\S+@\S+\.\S+/
      return re.test(searching_data)
    },
    delete_item(device_id){
      this.deleted_item = device_id
      this.show_delete_validation = true
    },
    delete_device(){
      if(this.deleted_item != null &&
         this.deleted_item != '' &&
         this.deleted_item != undefined){
        try {
          this.$http.post('app/access_devices/delete',
            {
              id: this.deleted_item
            },{
            headers: {
                "X-Device-ID" : this.getDeviceId(),
                "Authorization" : 'Bearer ' + this.getUserToken()
            },
          }).then(function(response){
            console.log(response);
            this.find_access_devices();
            this.updateAlertMessage(response.body.message)
            this.updateIsInAlert(true);
          }, function(response){
            console.log(response);
            this.updateAlertMessage('No se pudo procesar la petición')
            this.updateIsInAlert(true);
          })
        } catch (e) {
          this.updateAlertMessage(e.message)
          this.updateIsInAlert(true);
        }
      }else{
        this.updateAlertMessage('Ha ocurrido un problema, porfavor intentelo mas tarde')
        this.updateIsInAlert(true);
      }
      this.show_delete_validation = false
    },
    filter_device_type(value){
      switch (value) {
        case '5':
          return 'Tag'
          break;
        case '6':
          return 'Tarjeta'
          break;
        case '7':
          return 'Sticker'
          break;
        case '8':
          return 'Manilla'
          break;
        case '11':
          return 'Generico'
          break;
        case '15':
          return 'Carro'
          break;
        case '16':
        return 'Moto'
        break;
        default:
          return 'Otro'
          break;
      }
    }
  },
  mounted(){
    console.log(this.user);
  },
  watch:{
    searching_data(){
      this.valid = false
    },
    show_delete_validation(){
      if(this.show_delete_validation == false){
        this.deleted_item = null
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/views/users/access_devices/AccessDevices.vue